const MAX_ATTEMPTS = 3;

export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  const status = (error as { response?: { status?: number } })?.response
    ?.status;
  const isServerOrNetworkError = status === undefined || status >= 500;

  return isServerOrNetworkError && failureCount < MAX_ATTEMPTS;
}
